import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";
import { Tiptap, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

import { colors } from "@dotnet/telematics-design-system";

import { useBannerStyles } from "shared";

import Toolbar from "./Toolbar";
import { EditorProps } from "./types";

const Editor = ({ content, isDisabled, onMessageChange }: EditorProps) => {
    const { gray100, gray300, gray700, white } = colors;

    const { t } = useTranslation();
    const { generalStyles } = useBannerStyles();

    const editor = useEditor({
        extensions: [
            StarterKit.configure({
                link: {
                    defaultProtocol: "https"
                }
            })
        ],
        content,
        autofocus: true,
        onCreate({ editor }) {
            editor.commands.focus("end");
        },
        onUpdate({ editor }) {
            if (editor.isEmpty) {
                onMessageChange(null);
            } else {
                onMessageChange(editor.getJSON());
            }
        }
    });

    return (
        <div
            css={css({
                marginTop: "16px"
            })}
        >
            <div
                css={css({
                    color: gray700,
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                    marginBottom: "4px"
                })}
            >
                {t("Banner##message")}
            </div>

            <div
                css={css({
                    background: isDisabled ? gray100 : white,
                    border: `1px solid ${gray300}`,
                    borderRadius: "6px",
                    padding: "12px",
                    pointerEvents: isDisabled ? "none" : "auto",

                    "& .tiptap": {
                        minHeight: "143px",
                        ...generalStyles,

                        "&:focus-visible": {
                            outline: "none"
                        }
                    }
                })}
            >
                <Tiptap editor={editor}>
                    <Toolbar isDisabled={isDisabled} />
                    <Tiptap.Content />
                </Tiptap>
            </div>
        </div>
    );
};

export default Editor;
